import { MessageMedium } from 'modules/graphql/types';

import { WYSIWYG_DEFAULT_ID } from '../constants';
import { useWYSIWYGContext } from '../contexts/WYSIWYGContext';
import { useRenderTinyEffect, useUndoManagerEffect } from '../hooks';
import { WYSIWYGModals } from '../modals/WYSIWYGModals';
import { HiddenInput } from './HiddenInput';
import { TinyMCEEditor } from './tinyMCE';

type EditorProps = Partial<{
  height: number | string;
  id: string;
  contentLocale: string;
  canUseAutoCompleteParams: boolean;
  messageMedium: MessageMedium;
}>;

export const Editor = ({
  canUseAutoCompleteParams = false,
  contentLocale = '',
  height = 500,
  id = WYSIWYG_DEFAULT_ID,
  messageMedium,
}: EditorProps) => {
  const { renderTiny, canLoadHTML } = useWYSIWYGContext();

  useUndoManagerEffect(contentLocale);
  useRenderTinyEffect();

  return (
    <>
      {canLoadHTML && <HiddenInput />}
      {renderTiny && (
        <TinyMCEEditor
          canUseAutoCompleteParams={canUseAutoCompleteParams}
          height={height}
          messageMedium={messageMedium}
          id={id}
        />
      )}
      <WYSIWYGModals />
    </>
  );
};
